// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3pbLV","topBottomGutter":"Layout_topBottomGutter__RLGhR"};